import React, { useEffect } from 'react'
import Cookies from 'universal-cookie'
import { GoogleAnalyticsProps } from './trackers'

const cookies = new Cookies()
// TODO: Re-factor into a hook
/**
 * @docs https://developers.google.com/analytics/devguides/collection/analyticsjs/events
 */
export const GoogleAnalytics = ({ gaProfileId, gaOptimizeId }: GoogleAnalyticsProps): null => {
  useEffect(() => {
    const debug = !!cookies.get('ga_debug')

    // Support old disable-mechanism
    if (cookies.get(`ga-disable-${gaProfileId}`)) return

    // Include GA script
    const firstScript = document.getElementsByTagName('script')[0]
    const gaScript = document.createElement('script')
    gaScript.async = true
    gaScript.src = `https://www.google-analytics.com/analytics${debug ? '_debug' : ''}.js`
    firstScript.parentNode?.insertBefore(gaScript, firstScript)

    // Execute GA init ceremony
    if (debug) window.ga_debug = { trace: true }
    window.ga('create', gaProfileId)
    window.ga('set', 'anonymizeIp', true)
    window.ga('set', 'dimension1', cookies.get('ga_dimension1'))
    window.ga('set', 'dimension2', getDevicePixelRatio())
    window.ga('set', 'dimension4', I18n.locale)
    if (window.gaTrackingPath) window.ga('set', 'dimension5', window.gaTrackingPath)
    if (gaOptimizeId) window.ga('require', gaOptimizeId)
    window.ga('send', 'pageview')

    if (window.gaTrackingPathDebug) {
      const current_url = window.location.pathname + window.location.search + window.location.hash
      window.ga('send', 'event', 'tracking path debugging', window.gaTrackingPathDebug, current_url, {
        nonInteraction: true,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // TODO: Determine whether it should depend on ids

  return null
}

/**
 * @desc Based on GetDevicePixelRatio | Author: Tyson Matanich, 2012 | License: MIT https://github.com/tysonmatanich/GetDevicePixelRatio
 */
const getDevicePixelRatio = (): string => {
  let ratio = 1
  // Legacy-land
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const IEScreen: { systemXDPI: number; logicalXDPI: number } = window.screen as any
  // To account for zoom, change to use deviceXDPI instead of systemXDPI
  if (
    IEScreen.systemXDPI !== undefined &&
    IEScreen.logicalXDPI !== undefined &&
    IEScreen.systemXDPI > IEScreen.logicalXDPI
  ) {
    // Only allow for values > 1
    ratio = IEScreen.systemXDPI / IEScreen.logicalXDPI
  } else if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio
  }

  /* Customization for betterplace: we want a rounded value, 1 decimal position, as string: */
  return (Math.round(ratio * 10) / 10).toString()
}
